import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { EMPTY, Observable } from 'rxjs';

const _baseURL = "https://d2e6d30q686u4a.cloudfront.net";

@Injectable()
export class SEOService {

  constructor(
    @Inject(DOCUMENT) private dom:any,
    private title: Title,
    private meta: Meta,
    private http: HttpClient
  ) { }
  
  // setTitle : define a new name for the browsers tab
  setTitle(title: string){
    if(title){
      this.title.setTitle(title)
    }
  }

  // setFavicon : define a new favicon provided to us form the customer
  setFavicon(ico: string) {
    if(ico !== 'favicon.ico'){
      // remove existing static favicon
      const link2 = this.dom.getElementById("favico")
      link2.removeAttribute("href");
      link2.removeAttribute("rel");
      link2.removeAttribute("type");
    
      // add a new <link> element of rel icon
      const link: HTMLLinkElement = this.dom.createElement('link');
      link.setAttribute('rel', 'icon');
      link.setAttribute('type', 'image/x-icon');
      link.setAttribute('href', `${_baseURL}/favicons/${ico}`);
      this.dom.head.appendChild(link);
    }
  }

  // updateDescription : change the current description of the active tab
  updateDescription(content: string) {
    if(content){
      this.meta.updateTag({ name: 'description', content });
    }
  }

  getSEOMetadata(companyId: number) {
    return this.http.get<{title:string,fav_icon:string}>(`${_baseURL}/${companyId}/seo.json`);
  }

  // getSEO : collect SEO metadata for a given agency
  getSEO(id:number):Observable<any>{
    return this.http.get<{title:string,fav_icon:string}>(`${_baseURL}/${id}/seo.json`).pipe(
      tap((seo) => this._setBrowserTab(seo)),
      catchError((_) => {
        return EMPTY
        // TODO: should we want to manage our SEO via AWS this should be uncommented
        // return this.http.get<{title:string,fav_icon:string}>(`${_baseURL}/seo.json`).pipe(
        //   tap((seo) => this._setBrowserTab(seo))
        // )
      })
    )
  }

  private _setBrowserTab(seo:{title:string,fav_icon:string}){
    this.setFavicon(seo?.fav_icon);
    this.setTitle(seo?.title);
  }
}